function escapeText(value: string): string {
  return value.replace(/\\/g, '\\\\').replace(/\r\n|\r|\n/g, '\\n').replace(/;/g, '\\;').replace(/,/g, '\\,');
}

function foldLine(line: string): string {
  let folded = '';
  let bytes = 0;
  // vCard lines fold at 75 UTF-8 bytes, without splitting a Unicode character.
  for (const character of Array.from(line)) {
    const point = character.codePointAt(0)!;
    const size = point <= 0x7f ? 1 : point <= 0x7ff ? 2 : point <= 0xffff ? 3 : 4;
    if (bytes + size > 75) {
      folded += '\r\n ';
      bytes = 1;
    }
    folded += character;
    bytes += size;
  }
  return folded;
}

export function createEmailVCard(name: string, email: string): string {
  if (!name.trim() || !email.trim()) { throw new Error('Contact name and email are required'); }
  // Version 3.0 works with Apple Contacts, Google Contacts and Outlook.
  return [
    'BEGIN:VCARD',
    'VERSION:3.0',
    `FN:${escapeText(name)}`,
    `N:;${escapeText(name)};;;`,
    `EMAIL;TYPE=INTERNET:${escapeText(email)}`,
    'END:VCARD',
  ].map(foldLine).join('\r\n') + '\r\n';
}

export function canDownloadEmailVCard(): boolean {
  return typeof document !== 'undefined' && typeof Blob !== 'undefined'
    && typeof URL !== 'undefined' && typeof URL.createObjectURL === 'function'
    && typeof URL.revokeObjectURL === 'function';
}

export function downloadEmailVCard(name: string, email: string): void {
  const card = new Blob([createEmailVCard(name, email)], { type: 'text/vcard;charset=utf-8' });
  const url = URL.createObjectURL(card);
  const link = document.createElement('a');
  link.href = url;
  const filename = name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'contact';
  link.download = `${filename}.vcf`;
  link.style.display = 'none';
  try {
    document.body.appendChild(link);
    link.click();
  } finally {
    if (link.parentNode) { link.parentNode.removeChild(link); }
    // Let Safari and other browsers consume the URL before releasing it.
    window.setTimeout(() => URL.revokeObjectURL(url), 30000);
  }
}



// WEBPACK FOOTER //
// ./src/helpers/emailVCard.ts